/* Init */

// Normalize console
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});
    while(length--) {
        method = methods[length];
        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());


/*
    Set this as the master scroll event to keep a lot of code from firing on scroll.
    When you want to execute based on scroll behavior, use:
    setInterval(function() {
        if(scrolling) {
            scrolling = false;
            CODE();
        }
    }, 250);
*/
var scrolling = false;
window.addEventListener('scroll', function() {
    scrolling = true;
});


/********************************************************
** HELPER FUNCTIONS
********************************************************/
/*
    Any functions that have a jQuery equivalent I have tried to prefix with 'v' for vanilla.
*/

// Takes array 'a' and array 'b'
// Iterates through 'b' and either replaces missing values from 'a' to 'b' or replaces default values in 'a' with the value provided in 'b'
// This function is intedned to mimic the jQuery funtion "extend"
function vExtend(a, b) {
    for(var key in b) {
        if(b.hasOwnProperty(key)) {
            a[key] = b[key];
        }
    }
    return a;
}


// Takes a function 'fn'
// Executes 'fn' once the DOM has loaded (but before all assets finish loading)
function documentReady(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else if(document.addEventListener) {
        document.addEventListener('DOMContentLoaded', fn);
    } else {
        document.attachEvent('onreadystatechange', function() {
            if(document.readyState != 'loading') {
                fn();
            }
        });
    }
}


// Takes an element 'elem'
// Return true if an element is visisble and false if it is not
// function isVisible(elem) {
//     return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
// }
// Takes an element 'elem' and return bool if the element is visible or not
function isVisible(elem) {
    if(elem == null) {
        return null;
    } else {
        return !(elem.classList.contains("visuallyhidden") || elem.style.display == "none" || getComputedStyle(elem).display == "none" || elem.offsetWidth == 0 || elem.offsetHeight == 0 || elem.getClientRects().length == 0);
    }
}


// Takes an element 'elem' and an optional selector 'parentSelector'
// Returns an array of parent elements of 'elem', up to either document root or 'parentSelector' if it is provided
function getParents(elem, parentSelector) {
    if(parentSelector === undefined) {
        parentSelector = document;
    }
    var parents = [];
    var p = elem.parentNode;
    while(p !== parentSelector && p !== null) {
        var o = p;
        parents.push(o);
        p = o.parentNode;
    }
    parents.push(parentSelector);
    return parents;
}


// Takes an element 'el' and string 'tag'
// Returns an element that is a parent of 'el' and has the tagName property matching 'tag' or null if no such parent is found
// Please be aware that in javascript, the tagname property is often formatted as all uppercase, so matching div means tag should = DIV
function getParentElementWithTag(el, tag) {
    if (el.parentElement !== null) {
        var currentElement = el;
        while (currentElement.tagName !== tag.toUpperCase() && currentElement.parentElement !== null) {
            var objectPlaceholder = currentElement;
            currentElement = objectPlaceholder.parentElement;
        }
        if (currentElement.tagName !== tag.toUpperCase()) {
            currentElement = null;
        }
        return currentElement;
    } else {
        return null;
    }
}

// Takes an element 'el'
// Returns an element that is either 'el' or a parent of 'el' and has the passed class, or null if nothing is found
function getParentElementWithClass(elem, className) {
    if(elem !== null) {
        var currentElement = elem;
        while(!currentElement.classList.contains(className) && currentElement.parentElement !== null) {
            var objectPlaceholder = currentElement;
            currentElement = objectPlaceholder.parentElement;
        }
        if(!currentElement.classList.contains(className)) {
            currentElement = null;
        }
        return currentElement;
    } else {
        return null;
    }
}


// Takes an element 'el'
// Returns an true if one of the parents of 'el' has the class tablock or false if not
function isTablockChild(elem) {
    if(elem.parentElement !== null) {
        var parent = elem.parentElement;
        while(!parent.classList.contains("tablock") && parent.parentElement !== null) {
            var parentObject = parent;
            parent = parentObject.parentElement;
        }
        if(!parent.classList.contains("linkbox")) {
            parent = true;
        } else {
            parent = false;
        }
        return parent;
    } else {
        return false;
    }
}


// Takes an element 'elem'
// Returns true or false based on the presence of # in the href attribute of 'elem'
function isAnchorLink(elem) {
    isAnchor = false;
    if(elem.tagName === "A" && elem.hasAttribute("href") && elem.getAttribute("href").indexOf("#") > -1) {
        isAnchor = true;
    }
    return isAnchor;
}


// Takes an element 'el'
// Returns true if the element's content is overflowing passed that element's boundaries in the DOM
function isOverflown(el) {
  return el.scrollHeight > (parseInt(el.clientHeight) + 15);
}


// Takes target element 'to', number 'duration', and optional function 'callbackFunction'
// Animates the windows to scroll down to 'to' at speed of 'duration'
// If 'callbackFunction' is defined, executes this function when the animation is complete
function vScrollTo(to, duration, callbackFunction) {
    var element = document.scrollingElement || document.documentElement,
    start = element.scrollTop,
    change = to - start,
    startTs = performance.now();
    // t = current time
    // b = start value
    // c = change in value
    // d = duration
    function easeInOutQuad(t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
    }
    function animateScroll(ts) {
        var currentTime = ts - startTs;
        element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
        if(currentTime < duration) {
            requestAnimationFrame(animateScroll);
        } else {
            element.scrollTop = to;
            if(callbackFunction !== undefined) {
                callbackFunction();
            }
        }
    }
    requestAnimationFrame(animateScroll);
};


// Takes element 'elem' and returns the top offset of 'elem'
function getOffsetTop(elem) {
    var rect = elem.getBoundingClientRect();
    return rect.top + window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}


// Takes element 'elem' and returns the height, including padding and margins, of 'elem'
function vOuterHeight(elem) {
    var height = elem.offsetHeight;
    var style = elem.currentStyle || getComputedStyle(elem);
    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
    return height;
}


// Takes element 'elem', optional number 'duration', and optional function 'callbackFunction'
// Slides 'elem' open at the speed of 'duration'
// If 'duration' is not provided, uses 500 as the default speed
// If 'callbackFunction' is defined, executes this function when the slide animation is complete
function vSlideUp(elem, duration, callbackFunction) {
    if(duration === undefined) {
        duration = 500;
    }
    elem.style.transitionProperty = 'height, margin, padding';
    elem.style.transitionDuration = duration + 'ms';
    elem.style.boxSizing = 'border-box';
    elem.style.height = elem.offsetHeight + 'px';
    elem.offsetHeight;
    elem.style.overflow = 'hidden';
    elem.style.height = 0;
    elem.style.paddingTop = 0;
    elem.style.paddingBottom = 0;
    elem.style.marginTop = 0;
    elem.style.marginBottom = 0;
    window.setTimeout(function() {
        elem.style.display = 'none';
        elem.style.removeProperty('height');
        elem.style.removeProperty('padding-top');
        elem.style.removeProperty('padding-bottom');
        elem.style.removeProperty('margin-top');
        elem.style.removeProperty('margin-bottom');
        elem.style.removeProperty('overflow');
        elem.style.removeProperty('transition-duration');
        elem.style.removeProperty('transition-property');
        if(callbackFunction !== undefined) {
            callbackFunction();
        }
    }, duration);
}


// Takes element 'elem', number 'duration', optional string 'display', and optional function 'callbackFunction'
// Slides 'elem' open at the speed of 'duration' if 'elem' display is set to "none"
// If 'duration' is not provided, uses 500 as the default speed
// Will set the CSS property "display" of 'elem' to 'display' or to "block" if 'display' is not set
// If 'callbackFunction' is defined, executes this function when the slide animation is complete
function vSlideDown(elem, duration, display, callbackFunction) {
    if(duration === undefined) {
        duration = 500;
    }
    elem.style.removeProperty('display');
    var displayValue = window.getComputedStyle(elem).display;
    if(displayValue === 'none' && display === undefined) {
        displayValue = 'block';
    } else if(displayValue === 'none') {
        displayValue = display;
    }
    elem.style.display = displayValue;
    var height = elem.offsetHeight;
    elem.style.overflow = 'hidden';
    elem.style.height = 0;
    elem.style.paddingTop = 0;
    elem.style.paddingBottom = 0;
    elem.style.marginTop = 0;
    elem.style.marginBottom = 0;
    elem.offsetHeight;
    elem.style.boxSizing = 'border-box';
    elem.style.transitionProperty = "height, margin, padding";
    elem.style.transitionDuration = duration + 'ms';
    elem.style.height = height + 'px';
    elem.style.removeProperty('padding-top');
    elem.style.removeProperty('padding-bottom');
    elem.style.removeProperty('margin-top');
    elem.style.removeProperty('margin-bottom');
    window.setTimeout(function() {
        elem.style.removeProperty('height');
        elem.style.removeProperty('overflow');
        elem.style.removeProperty('transition-duration');
        elem.style.removeProperty('transition-property');
        if(callbackFunction !== undefined) {
            callbackFunction();
        }
    }, duration);
}


// Takes an element 'elem' a number 'duration' and a string 'display'
// Slides 'elem' open at the speed of 'duration' if 'elem' display is set to "none"
// Slides 'elem' closed at the speed of 'duration' if 'elem' display is set to anything other than "none"
// If 'duration' is not provided, uses 500 as the default speed
// Optional attribute 'display' can be used to set what the CSS display property of 'elem' is set to when the vSlideDown animation is complete
function vSlideToggle(elem, duration, display) {
    if(duration === undefined) {
        duration = 500;
    }
    if(window.getComputedStyle(elem).display === 'none') {
        if(display === undefined) {
            return vSlideDown(elem, duration);
        } else {
            return vSlideDown(elem, duration, display);
        }
    } else {
        return vSlideUp(elem, duration);
    }
}


// Takes an element 'elem' and fades 'elem' out, and then sets the display CSS property of 'elem' to 'none' once the fade animaton is complete
function vFadeOut(elem) {
    elem.style.opacity = 1;
    (function fade() {
        if ((elem.style.opacity -= .1) < 0) {
            elem.style.display = "none";
        } else {
            requestAnimationFrame(fade);
        }
    })();
};


// Takes an element 'elem' and an optional string 'display' and fades 'elem' in, and then sets the display CSS property of 'elem' to 'display' once the fade animaton is complete
// Will set CSS display proerty to 'block' as a fallback if none is provided
function vFadeIn(elem, display) {
    elem.style.opacity = 0;
    elem.style.display = display || "block";
    (function fade() {
        var val = parseFloat(elem.style.opacity);
        if (!((val += .1) > 1)) {
            elem.style.opacity = val;
            requestAnimationFrame(fade);
        }
    })();
};


// Takes an element 'elem' and an optional string 'display' and sets the display CSS property of 'elem' to 'display'
// Will set CSS display proerty to "block" as a fallback if none is provided
function vShow(elem, display) {
    elem.style.display = display || "block";
}


// Takes an element 'elem' and sets the display CSS property of 'elem' to "none"
function vHide(elem) {
    elem.style.display = "none";
}


// Takes an element 'elem' and focuses the first selectable element within it
// Return null if no selectable element is found
function focusFirst(elem) {
    if(elem !== null) {
        let selectableElements = elem.querySelectorAll("a, input, textarea, button");
        for(var i = 0; i < selectableElements.length; i++) {
            if(isVisible(selectableElements[i])) {
                selectableElements[i].focus();
                return true;
            }
        }
    }
    return false;
}


// Takes an element 'elem' and focuses the last selectable element within it
// Return null if no selectable element is found
function focusLast(elem) {
    if(elem !== null) {
        var selectableElements = elem.querySelectorAll("a, input, textarea, button");
        for(var i = (selectableElements.length - 1); i > -1; i--) {
            if(isVisible(selectableElements[i])) {
                selectableElements[i].focus();
                return true;
            }
        }
    }
    return false;
}


// Takes an element 'elem' and returns the first selectable and visible element within 'elem' or null if none is found
function getFirstSelectableElement(elem) {
    if(elem !== null) {
        var selectableElements = elem.querySelectorAll("button, a, input, select, textarea");
        if(selectableElements.length) {
            for(i = 0; i < selectableElements.length; i++) {
                if(selectableElements[i].tabIndex === 0 && isVisible(selectableElements[i])) {
                    return selectableElements[i];
                }
            }
        }
    }
    return null;
}


// Takes an element as 'elem' returns the last selectable and visible element within 'elem' or null if none is found
function getLastSelectableElement(elem) {
    if(elem !== null) {
        var selectableElements = elem.querySelectorAll("button, a, input, select, textarea");
        if(selectableElements.length) {
            for(i = (selectableElements.length - 1); i > -1; i--) {
                if(selectableElements[i].tabIndex === 0 && isVisible(selectableElements[i])) {
                    return selectableElements[i];
                }
            }
        }
    }
    return null;
}


/********************************************************
** SPEEDBUMP
********************************************************/
/*
    Displays a dialog when users click on certain links that have the speedbump class and that will navigate them away from the current site
*/
function speedbump(options) {
    // Options
    var settings = vExtend({
        // These are the defaults

        // Speedbump box title text
        header: "You are continuing to another website.",

        // Speedbump box message text
        message: "You will be linking to another website not owned or operated by us. We do not control these sites and do not guarantee the accuracy, completeness, efficiency or timeliness of the information contained therein. We encourage you to review their privacy and security policies which may differ from ours.",

        // Speedbump box cancel button text
        button_cancel: "Return to Our Site",

        // Speedbump box OK button text
        button_ok: "OK",

        // Speedbump box element ID
        id: "default",

        // Optional: speedbump box function code to execute when the OK button is clicked
        // Will not execute if target="_self"
        confirm_function: null,

        // Optional: speedbump box function code to execute when the cancel button is clicked. Also executed on ESC
        cancel_function: null,

        // Speedbump box URL for the OK button. If left blank, automatically pulled from clicked element
        ok_link: "",

        // Spedbump box target (_self, _blank) for the OK button
        window_target: "_self"

        // 'clickedElement' is also passed, but isn't overwritten because it should never be provided as a default
    }, options);

    // If no link is provided to override, source it from the clicked element
    if(settings.ok_link === "") {
        settings.ok_link = settings.clickedElement.getAttribute("href");
    }

    // If the clicked element has no target, set as self, otherwise, set as the clicked element's target
    if(settings.clickedElement.hasAttribute("target") && settings.clickedElement.getAttribute("target") !== "") {
        settings.window_target = settings.clickedElement.getAttribute("target");
    }

    // If an ID exists, assign it
    if(settings.id != "") {
        settings.id = "_"+settings.id;
    }

    // Check to see if the markup for this speedbump has already been appended and if not append it
    if (document.querySelectorAll(".js-speedbump_pop" + settings.id).length === 0) {
        bodyElement = document.querySelector("body");
        var speedbumpElement = document.createElement('section');
        speedbumpElement.className = "js-speedbump_pop" + settings.id + " speedbump_back";
        speedbumpElement.style.display = "none";
        var speedbumpElementAttribute = document.createAttribute('aria-label')
        speedbumpElementAttribute.value = 'Speedbump - Please review';
        speedbumpElement.setAttributeNode(speedbumpElementAttribute);
        speedbumpElement.innerHTML = "<div class='speedbump_pop_inner'><div class='speedbump_pop_content tablock'></div></div>";
        bodyElement.appendChild(speedbumpElement);
    }

    // Assign a variable to refer to the speedbump we just added to the DOM
    var currentSpeedbump = document.querySelector(".js-speedbump_pop"+settings.id);

    // Build the speedbump inner HTML based on the values passed to settings and then set it
    var valid = true;
    var spb = "";
    if(settings.header != "") {
        spb += "<h2 class='speedbump_pop_header'>" + settings.header + "</h2>";
    }
    spb += "<div class='speedbump_pop_message'>" + settings.message + "</div>" +
            "<div class='speedbump_pop_buttons'>" +
            "<a href='"+settings.clickedElement.getAttribute("href")+"' class='cta-btn-orange js-speedbump_btn_ok"+settings.id+" speedbump_pop_btn speedbump_pop_btn_ok' target='"+settings.window_target+"' data-no-speedbump><span class='text'>" + settings.button_ok + "</span></a>" +
            "<button type='button' class='js-speedbump_btn_cancel"+settings.id+" cta-btn-white speedbump_pop_btn speedbump_pop_btn_cancel'><span class='text'>" + settings.button_cancel + "</span></button>" +
            "</div>";
    currentSpeedbump.querySelector(".speedbump_pop_content").innerHTML = spb;

    // Now that the markup is complete, set reference variables to the current speedbump for the rest of the code
    var currentSpeedbumpInner = currentSpeedbump.querySelector(".speedbump_pop_inner");
    var currentOKButton = currentSpeedbump.querySelector(".js-speedbump_btn_ok"+settings.id);
    var currentCancelbutton = currentSpeedbump.querySelector(".js-speedbump_btn_cancel"+settings.id);

    // ESC key behavior
    if(!currentSpeedbump.classList.contains("esc-bound")) {
        currentSpeedbump.addEventListener("keyup", function(event) {
            if(event.keyCode === 27 && currentSpeedbump.style.display !== "none") {
                setTimeout(function () {
                    currentSpeedbump.classList.remove("sb-active");
                }, "100");
                setTimeout(function () {
                    vHide(currentSpeedbump);
                }, "600");
                currentSpeedbump.removeAttribute("role");
                valid = false;
                if(settings.cancel_function !== null) {
                    settings.cancel_function();
                }
                settings.clickedElement.focus();
                return false;
            }
        });
        currentSpeedbump.classList.add("esc-bound");
    }

    // OK button click event
    if(!currentOKButton.classList.contains("bound")) {
        currentOKButton.addEventListener("click", function(event) {
            setTimeout(function () {
                currentSpeedbump.classList.remove("sb-active");
            }, "100");
            setTimeout(function () {
                vHide(currentSpeedbump);
            }, "600");
            currentSpeedbump.removeAttribute("role");
            if(settings.confirm_function !== null) {
                settings.confirm_function();
            }
        });
        currentOKButton.classList.add("bound");
    }

    // Cancel button click event
    if(!currentCancelbutton.classList.contains("bound")) {
        currentCancelbutton.addEventListener("click", function(event) {
            setTimeout(function () {
                currentSpeedbump.classList.remove("sb-active");
            }, "100");
            setTimeout(function () {
                vHide(currentSpeedbump);
            }, "600");
            currentSpeedbump.removeAttribute("role");
            valid = false;
            if(settings.cancel_function !== null) {
                settings.cancel_function();
            }
            settings.clickedElement.focus();
            return false;
        });
        currentCancelbutton.classList.add("bound");
    }

    //Move any tracking from link to confirm ok button
    currentOKButton.removeAttribute("data-track");
    currentOKButton.removeAttribute("data-event");
    currentOKButton.removeAttribute("data-track-category");
    currentOKButton.removeAttribute("data-track-action");
    currentOKButton.removeAttribute("data-track-value");

    if(settings.clickedElement.hasAttribute("data-track") && settings.clickedElement.getAttribute("data-track") !== "") {
        currentOKButton.setAttribute("data-track", settings.clickedElement.getAttribute("data-track"));
    }
    if(settings.clickedElement.hasAttribute("data-event") && settings.clickedElement.getAttribute("data-event") !== "") {
        currentOKButton.setAttribute("data-event", settings.clickedElement.getAttribute("data-event"));
    }
    if(settings.clickedElement.hasAttribute("data-track-category") && settings.clickedElement.getAttribute("data-track-category") !== "") {
        currentOKButton.setAttribute("data-track-category", settings.clickedElement.getAttribute("data-track-category"));
    }
    if(settings.clickedElement.hasAttribute("data-track-action") && settings.clickedElement.getAttribute("data-track-action") !== "") {
        currentOKButton.setAttribute("data-track-action", settings.clickedElement.getAttribute("data-track-action"));
    }
    if(settings.clickedElement.hasAttribute("data-track-value") && settings.clickedElement.getAttribute("data-track-value") !== "") {
        currentOKButton.setAttribute("data-track-value", settings.clickedElement.getAttribute("data-track-value"));
    }

    // The code to display the speedbump
    vShow(currentSpeedbump);
    currentSpeedbump.setAttribute("role", "alert");
    currentSpeedbump.setAttribute("data-url", settings.ok_link);
    setTimeout(function () {
        currentSpeedbump.classList.add("sb-active");
    }, "100");
    setTimeout(function () {
        currentOKButton.focus();
    }, "200");

    return false;
}


/********************************************************
** JUMPNAV CONDITIONAL HIGHLIGHTING
********************************************************/
/*
    Used to detect when the target of a jumplink scrolls into view so we can format those items as the currently displayed area
*/
setInterval(function() {
    if(scrolling) {
        scrolling = false;
        var jumpNavAnchors = document.querySelectorAll(".jump-nav a");
        var jumpNavAnchorParents = document.querySelectorAll(".jump-nav li");
        if(jumpNavAnchors !== null && jumpNavAnchors.length && jumpNavAnchorParents !== null && jumpNavAnchorParents.length) {
            for(i = 0; i < jumpNavAnchors.length; i++) {
                var sp = jumpNavAnchors[i].getAttribute("href").split("#");
                if(document.querySelector("[data-jn='"+sp[1]+"']").length && document.querySelector("[data-jn='"+sp[1]+"']").getBoundingClientRect().top - 100 < window.pageYOffset) {
                    for(j = 0; j < jumpNavAnchorParents.length; j++) {
                        jumpNavAnchorParents[i].classList.remove("current");
                    }
                    jumpNavAnchors[i].parentElement.classList.add("current");
                }
            }
        }
    }
}, 250);


/********************************************************
** Close Speedbump
********************************************************/
/*
    Reusable function to close / hide a speedbump on the site, also works for the confirm membership dialog
*/
function closeDialog(speedbumpElement, clickedElement, cancelFunction) {
    setTimeout(function() {
        speedbumpElement.classList.remove("dg-active");
    }, "100");
    setTimeout(function() {
        vHide(speedbumpElement);
    }, "600");
    speedbumpElement.removeAttribute("role");
    if(cancelFunction != undefined && cancelFunction !== null) {
        cancelFunction();
    }
    if(clickedElement != undefined && clickedElement !== null) {
        clickedElement.focus();
    }
    return false;
}


/********************************************************
** LINKBOX
********************************************************/
/*
    Makes an element's entire area a clickable link. Uses the href of the first link in the element as the link address
*/
// Event handler for linkbox links, including dynamic elements: Part 1, Click Events
document.addEventListener("click", function(event) {
    var linkboxElement = getParentElementWithClass(event.target, "linkbox");
    if(linkboxElement !== null) {
        var theLinkElement = linkboxElement.querySelector("a");
        if(theLinkElement !== null) {
            if(linkboxElement != theLinkElement) {
                theLinkElement.click();
            }
        }
    }
});
// Part 2, Hover Events
document.onmouseover = function(event) {
    var linkboxElement = getParentElementWithClass(event.target, "linkbox");
    if(linkboxElement !== null) {
        linkboxElement.querySelector("a").classList.add("hovered");
    }
}
document.onmouseout = function(event) {
    var linkboxElement = getParentElementWithClass(event.target, "linkbox");
    if(linkboxElement !== null) {
        linkboxElement.querySelector("a").classList.remove("hovered");
    }
}


/********************************************************
** SKIP LINK
********************************************************/
/*
    Behavior for when users on a screen reader click on the "skip to main content" link
*/
document.addEventListener("click", function(event) {
    if(event.target.classList.contains("js-skip-link")) {
        if(event.target.hasAttribute("href") && document.querySelector("main"+event.target.getAttribute("href")) !== null) {
            vScrollTo(document.querySelector("main"+event.target.getAttribute("href")), 1000, function() {
                document.querySelector("main a").focus();
            });
        }
    }
});


/********************************************************
** TABLOCK
********************************************************/
/*
    Prevents users from tabbing out of an area, such as a modal. Automatic based on the deepest container with class "tablock."
*/
document.addEventListener("keydown", function(event) {
    var activeElement = document.activeElement;
    if(event.key === "Tab" && isTablockChild(activeElement)) {
        var shift = event.shiftKey;
        tablockContainer = getParentElementWithClass(activeElement, "tablock");
        if(tablockContainer !== null) {
            var firstContainerElement = getFirstSelectableElement(tablockContainer);
            var lastContainerElement = getLastSelectableElement(tablockContainer);
            if(firstContainerElement !== null && lastContainerElement !== null) {
                if(firstContainerElement === activeElement && shift === true) {
                    event.preventDefault();
                    lastContainerElement.focus();
                    return false;
                } else if(lastContainerElement === activeElement && shift === false) {
                    event.preventDefault();
                    firstContainerElement.focus();
                    return false;
                }
            }
        }
    }
});

// Takes a string as 'cookieName', a string cookieValue, and an int 'numberOfDays' and creates a cookie by name name, with that value, and that lasts for that number of days
function setCookieValue(cookieName, cookieValue, numberOfDays) {
    var expires = new Date();
    expires.setDate(expires.getDate() + numberOfDays);
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + expires.toUTCString() + ";";
}

// Takes a string as 'cookieName' returns the value of that cookie or an empty string if no cookie with that name is found
function getCookieValue(cookieName) {
    // Get name followed by anything except a semicolon
    var cookiestring = RegExp(cookieName+"=[^;]+").exec(document.cookie);
    // Return everything after the equal sign, or an empty string if the cookie name not found
    return decodeURIComponent(!!cookiestring ? cookiestring.toString().replace(/^[^=]+./,"") : "");
}

// Takes a string as 'cookieName' and sets that cookie to expire immediately. Usually this will take effect on refresh and not instantly.
function clearCookie(cookieName) {
    document.cookie = cookieName+'=; expires=Thu, 01 Jan 1970 00:00:00 UTC; Max-Age=-99999999;';
}


/* Video Modal */
function getVideoID(videoURL) {
    let vid = null;
    if (videoURL.indexOf("vimeo") != -1) {
        vid = videoURL.replace("https://vimeo.com/", "");
        if (vid.indexOf("/") != -1) {
            vid = vid.substring(0, vid.indexOf("/"));
        }
    }
    else if (videoURL.indexOf("youtube") != -1) {
        vid = videoURL.replace("https://www.youtube.com/watch?v=", "");
        if (vid.indexOf("/") != -1) {
            vid = vid.substring(0, vid.indexOf("/"));
        }
    }
    else if (videoURL.indexOf("youtu.be") != -1) {
        vid = videoURL.replace("https://youtu.be/", "");
        if (vid.indexOf("/") != -1) {
            vid = vid.substring(0, vid.indexOf("/"));
        }
    }
    else if (videoURL.indexOf(".mp4")) {
        lastSlash = videoURL.lastIndexOf("/");
        vid = videoURL.substr(lastSlash + 1).replace(".mp4", "");
    }
    return vid.replace(/\W/gi, "");
}
function createShowVideoModal(videoURL, videoTitle = "Embedded Video", videoTranscript = 'Please <a href="' + CONTACTLINK + '">contact us</a> for a transcript of this video.') {
    if(null != videoURL && !videoURL.empty) {
        let videoID = getVideoID(videoURL);
        if(null != videoID && null != document.getElementById("video_modal_" + videoID)) {
            let videoModal = document.getElementById("video_modal_" + videoID);
            vShow(videoModal);
            focusFirst(videoModal);
            return true;
        } else if (null != videoID) {
            let videoCaption = "";
            let vidBuild = '<div class="video-flex-container"><div class="video-modal-content"><button class="video-modal-close js-video-modal-close" aria-lable="Close this video modal."><span class="button-symbol"></span></button>';
            if (videoURL.indexOf("vimeo") != -1) {
                vidBuild += '<div class="video-holder"><iframe src="https://player.vimeo.com/video/' + videoID + '?title=0&byline=0&portrait=0" alt="' + videoTitle + '" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>';
                vidBuild += '<div class="transcript-container js-accordion-container"><button class="transcript-button js-accordion-button" type="button" aria-expanded="false">Video Transcript</button><div class="transcript-content js-accordion-content"><p>This video uses Vimeo\'s native closed captioning features to provide a transcript. If closed captioning is unavailable for this video, please <a href="/contact/">contact us</a> and we can provide you with one.</p></div></div>';
            }
            else if (videoURL.indexOf("youtube") != -1 || videoURL.indexOf("youtu.be") != -1) {
                vidBuild += '<div class="video-holder"><iframe src="https://www.youtube.com/embed/' + videoID + '" alt="' + videoTitle + '" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="accelerometer; autoplay; encrypted - media; gyroscope; picture -in -picture; fullscreen" allowfullscreen></iframe></div>';
                vidBuild += '<div class="transcript-container js-accordion-container"><button class="transcript-button js-accordion-button" type="button" aria-expanded="false">Video Transcript</button><div class="transcript-content js-accordion-content"><p>This video uses YouTube\'s native closed captioning features to provide a transcript. If closed captioning is unavailable for this video, please <a href="/contact/">contact us</a> and we can provide you with one.</p></div></div>';
            }
            else if (videoURL.indexOf(".mp4")) {
                vidBuild += '<video class="local-video" controls autoplay><source src="' + videoURL + '" type="video/mp4"></video>';

                vidBuild += '<div class="transcript-container js-accordion-container"><button class="transcript-button js-accordion-button" type="button" aria-expanded="false">Video Transcript</button><div class="transcript-content js-accordion-content"></div></div>';
            }
            vidBuild += "</div></div>";

            var vidModal = document.querySelector(".video-modal");
            if (vidModal !== null) {
                vidModal.parentNode.removeChild(vidModal);
            }

            let videoContainerDiv = document.createElement("div");
            videoContainerDiv.classList.add("video-modal");
            videoContainerDiv.classList.add("js-video-modal");
            videoContainerDiv.setAttribute("id", "video_modal_" + videoID);
            videoContainerDiv.innerHTML = vidBuild;
            document.body.appendChild(videoContainerDiv);
            // Setup the accordions that were just added dynamically
            initAccordions();
            // ESC key behavior
            if(!videoContainerDiv.classList.contains("esc-bound")) {
                videoContainerDiv.addEventListener("keyup", function(event) {
                    if(event.keyCode === 27 && videoContainerDiv.style.display !== "none") {
                        closeVideoModal(videoContainerDiv);
                    }
                });
                videoContainerDiv.classList.add("esc-bound");
            }
            focusFirst(videoContainerDiv);
        }
        return true;
    } else {
        return null;
    }
}
function closeVideoModal(videoModal = null) {
    if(null != videoModal) {
        vHide(videoModal);
        let videoModalTriggerElement = document.querySelector(".js-video-modal-trigger-element");
        if(null != videoModalTriggerElement) {
            videoModalTriggerElement.focus();
            videoModalTriggerElement.classList.remove("js-video-modal-trigger-element");
        }
    }
}
/* Click event to trigger video modal */
document.addEventListener("click", function(event) {
    if(null != event.target.getAttribute("data-video") && event.target.getAttribute("data-video") != "") {
        event.preventDefault();
        let videoTitle = "Embedded Video";
        if(null != event.target.getAttribute("data-title")) {
            videoTitle = event.target.getAttribute("data-title");
        }
        let videoTranscript = 'Please <a href="' + CONTACTLINK + '">contact us</a> for a transcript of this video.';
        if(null != event.target.querySelector('.js-transcript')) {
            videoTranscript = event.target.querySelector('.js-transcript').innerHTML;
        }
        event.target.classList.add("js-video-modal-trigger-element");
        createShowVideoModal(event.target.getAttribute("data-video"), videoTitle, videoTranscript);
    }
});
/* Click event to close video modal */
document.addEventListener("click", function(event) {
    let videoModalCloseButton = getParentElementWithClass(event.target, "js-video-modal-close");
    if(null != videoModalCloseButton) {
        let videoModal = getParentElementWithClass(videoModalCloseButton, "js-video-modal");
        closeVideoModal(videoModal);
    }
});

// Takes a string and returns it with all words capitalized.
function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}